import ToggleItem from './toggle_item';
import { TEXT_WRAP } from '../../constant';

export default class TextWrap extends ToggleItem {
  constructor() {
    super(TEXT_WRAP);
  }
}
